var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19487 7.89211e-07L9.51748e-09 0L10.2564 10L20 -7.58732e-08L17.3179 6.21918e-08L10.2564 4.25701e-07L3.19487 7.89211e-07Z",
    fill: "#7256CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownPurple);
export default __webpack_public_path__ + "static/media/arrow-down-purple.4787b17dbb793fe5015779de1f7207ba.svg";
export { ForwardRef as ReactComponent };